import React from 'react';
import PropTypes from 'prop-types';

const IPropTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
};

const defaultProps = {
  className: '',
};

const DENSITIES = ['1x', '2x'];

const generateSrcSet = src => (
  DENSITIES.map(density => `${src}-${density}.jpg ${density}`).join(', ')
);

const MenuImage = props => (
  <img
    alt=""
    className={props.className}
    src={`${props.src}-1x.jpg`}
    srcSet={generateSrcSet(props.src)}
  />
);

MenuImage.propTypes = IPropTypes;
MenuImage.defaultProps = defaultProps;

export { MenuImage };



// WEBPACK FOOTER //
// ./src/common/home-navbar/menu-image/MenuImage.jsx